export default "__VITE_ASSET__DgwJ$Io4__"